import type { SVGProps } from 'react';

export const Tag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    version="1.1"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{'icons/base price'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <rect height="32" width="32" x="0" y="0"></rect>
      <g
        stroke="#898C9A"
        strokeLinecap="round"
        transform="translate(1.9198, 1.92)"
      >
        <circle cx="22.62016" cy="5.7" r="2.5" strokeWidth="2"></circle>
        <path
          d="M28.16016,1.6 C28.16016,0.71616 27.444,0 26.56016,0 C26.46032,0 17.03952,0.00128 17.03952,0.00128 C16.18832,0.00128 15.3736,-0.04352 14.90128,0.4288 L0.35472,14.97472 C-0.11824,15.44704 -0.11824,16.21376 0.35472,16.68608 L11.47408,27.80544 C11.9464,28.27776 12.71312,28.27776 13.18544,27.80544 L27.73136,13.25888 C28.20368,12.7872 28.15888,11.99168 28.15888,11.12128 C28.15888,11.12128 28.16016,1.69984 28.16016,1.6 Z"
          strokeWidth="2.5"
        ></path>
      </g>
    </g>
  </svg>
);
